import React from 'react'
import cx from 'classnames'
import { Box } from 'components/layout/Box/Box'
import { Checkbox } from 'components/shared/FormFields/common/Checkbox/Checkbox'
import { Table } from 'components/shared/Table/Table'

import styles from './CheckboxCell.module.scss'

export const CheckboxCell = ({
  type,
  onChange,
  hasIncreasedHeight,
  isChecked,
  isIndeterminate,
  isDisabled,
  className,
}) => {
  const ref = React.useRef(null)

  return (
    <Table.Cell
      className={cx(styles.cell, className)}
      {...{ type, hasIncreasedHeight }}
    >
      <Box align="center" justify="center" tagName="span">
        <Checkbox
          value={isChecked}
          {...{ ref, onChange, isIndeterminate, isDisabled }}
        />
      </Box>
    </Table.Cell>
  )
}
